<template>
  <div class="profile-list">
    <template v-if="profiles.length > 0">
      <ProfilerCard
        v-for="profile in profiles"
        :key="profile.id || profile.name"
        :profile="profile"
        @profile-clicked="$emit('profile-clicked', $event)"
        @profile-updated="$emit('profile-updated')"
        @add-validation-session="$emit('add-validation-session')"
      />
    </template>

    <div v-else class="profile-list__empty">
      No profiling sessions found.
    </div>
  </div>
</template>

<script setup>
import ProfilerCard from '@/components/ProfilerComponents/ProfilerCard.vue';

defineProps({
  profiles: {
    type: Array,
    default: () => [],
  },
});

defineEmits(['profile-clicked', 'profile-updated', 'add-validation-session']);
</script>

<style lang="scss" scoped>
.profile-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0 20px 20px;
}

.profile-list__empty {
  min-height: 160px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  @include themify() {
    color: themed('body-text-color');
    background: themed('color-white-200');
  }
}
</style>
